import script from "./HistoriaDeOfertasView.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoriaDeOfertasView.vue?vue&type=script&setup=true&lang=js"

import "./HistoriaDeOfertasView.vue?vue&type=style&index=0&id=e7893758&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7893758"]])

export default __exports__